'use client'

import type { ReactNode } from 'react'

import { Button, Icon } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { Logo } from '@common/components/Logo'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

type MobileMenuHeaderProps = {
  additionalActions?: ReactNode
  showFeedback?: boolean
  showNotifications?: boolean
  showSearch?: boolean
}

export function MobileMenuHeader({
  showSearch = true,
  showFeedback = true,
  showNotifications = true,
  additionalActions,
}: MobileMenuHeaderProps) {
  const { isScrolled, notificationBadge, onClose, onNotificationClick, setIsHelpDrawerOpen, showHelpSelector } =
    useMobileMenuContext()

  return (
    <div
      className={`${styles.header} ${isScrolled ? styles.headerScrolled : ''}`}
      data-testid={MOBILE_MENU_TEST_IDS.header}
    >
      <div className={styles.headerLogo}>
        <Logo />
      </div>

      <div className={styles.headerActions}>
        {showSearch ? (
          <Button iconOnly size="l" variant="ghost" icon={Icon.SearchRegular} disabled className={styles.search} />
        ) : null}
        {showFeedback ? (
          <Button
            iconOnly
            size="l"
            variant="ghost"
            icon={Icon.QuestionCircleRegular}
            disabled={!showHelpSelector}
            onClick={showHelpSelector ? () => setIsHelpDrawerOpen(true) : undefined}
            className={styles.feedback}
          />
        ) : null}
        {showNotifications ? (
          <div className={styles.notificationBtn}>
            <Button
              iconOnly
              size="l"
              variant="ghost"
              icon={Icon.AlertRegular}
              disabled={!onNotificationClick}
              onClick={onNotificationClick}
              className={styles.notification}
            />
            {!!notificationBadge && notificationBadge > 0 ? (
              <span className={styles.notificationBadge} aria-hidden="true">
                {notificationBadge}
              </span>
            ) : null}
          </div>
        ) : null}
        {additionalActions}
        <Button iconOnly size="l" variant="ghost" icon={Icon.DismissRegular} onClick={onClose} />
      </div>
    </div>
  )
}
